import {
  GET_CLIENTLIST_NETWORK,
  GET_PACKAGE_CREATION,
  GET_FACILITYCATEGORY_NETWORK,
  GET_ALLTESTCREATION_NETWORK,
  GET_PREPARATION_FOR_CHECKUP,
  GET_DIAGNOSTICS_DETAILS,
  GET_TEST_CREATION_DETAIL,
  GET_PARAMETER_CREATION_DETAILS,
  GET_SERVICE_CREATION_DETAIL,
} from "../../Utils/types";

const initialState = {
  getPackageCreation: [],
  getClientListNetwork: [],
  getFacilityCategoryNetwork: [],
  getAllTestCategoryNetwork: [],
  getPreparationForCheckup: [],
  getDiagnosticsDetails: [],
  getTestCreation: [],
  getParameterCreation: [],
  getServiceCreationDetail:[]
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PACKAGE_CREATION:
      return {
        ...state,
        getPackageCreation: action.payload,
      };
    case GET_CLIENTLIST_NETWORK:
      return {
        ...state,
        getClientListNetwork: action.payload,
      };
    case GET_FACILITYCATEGORY_NETWORK:
      return {
        ...state,
        getFacilityCategoryNetwork: action.payload,
      };
    case GET_ALLTESTCREATION_NETWORK:
      return {
        ...state,
        getAllTestCategoryNetwork: action.payload,
      };
    case GET_PREPARATION_FOR_CHECKUP:
      return {
        ...state,
        getPreparationForCheckup: action.payload,
      };
    case GET_DIAGNOSTICS_DETAILS:
      return {
        ...state,
        getDiagnosticsDetails: action.payload,
      };
    case GET_TEST_CREATION_DETAIL:
      return {
        ...state,
        getTestCreation: action.payload,
      };
    case GET_PARAMETER_CREATION_DETAILS:
      return {
        ...state,
        getParameterCreation: action.payload,
      };
    case GET_SERVICE_CREATION_DETAIL:
      return {
        ...state,
        getServiceCreationDetail: action.payload,
      };
    default:
      return state;
  }
};
